module.exports = __webpack_public_path__ + "img/about-ch2-urbanproblems-globe.98b6e824.svg";